'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { shouldUpdatePreviewer } from 'DesignData/selectors/app';
import { getPreviewerWindow } from 'DesignData/selectors/previewer';
import UIToolBar from 'UIComponents/nav/UIToolBar';
import UIToolBarGroup from 'UIComponents/nav/UIToolBarGroup';

const mapStateToProps = state => {
  return {
    previewerWindow: getPreviewerWindow(state),
    updatePreviewer: shouldUpdatePreviewer(state)
  };
};

class Toolbar extends PureComponent {
  constructor(...args) {
    super(...args);

    this.updatePreviewer = () => {
      const {
        previewerWindow,
        previewUrl,
        updatePreviewer
      } = this.props;

      if (previewerWindow && updatePreviewer && previewUrl) {
        previewerWindow.location = previewUrl;
      }
    };
  }

  componentDidMount() {
    this.updatePreviewer();
  }

  componentDidUpdate(prevProps) {
    if (this.props.previewUrl !== prevProps.previewUrl) {
      this.updatePreviewer();
    }
  }

  render() {
    const {
      className,
      disabled,
      leftContent,
      rightContent,
      middleContent
    } = this.props;
    const toolbarClassName = classNames('editor-toolbar', className, disabled && "disabled");
    return /*#__PURE__*/_jsxs(UIToolBar, {
      className: toolbarClassName,
      children: [/*#__PURE__*/_jsx(UIToolBarGroup, {
        children: leftContent
      }), /*#__PURE__*/_jsx(UIToolBarGroup, {
        children: middleContent
      }), /*#__PURE__*/_jsx(UIToolBarGroup, {
        children: rightContent
      })]
    });
  }

}

Toolbar.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  leftContent: PropTypes.node,
  rightContent: PropTypes.node,
  middleContent: PropTypes.node,
  previewerWindow: PropTypes.object,
  updatePreviewer: PropTypes.bool.isRequired,
  previewUrl: PropTypes.string
};
Toolbar.defaultProps = {
  disabled: false,
  renderSettings: true
};
export default connect(mapStateToProps)(Toolbar);